import React from 'react'
import Header from "../template/Header";
import AppFooter from "../template/Footer";
import AppContent from "../template/Content";
import AppSidebar from "../template/Sidebar";
import ToggleHeaderButton from "../template/ToggleHeaderButton";
import {StateContext} from "../context/StateProvider";
import AuthService from "../../services/auth.service";
import {esCuentaPantalla} from "../../config/roles";

export default class DefaultLayout extends React.Component {

    static contextType = StateContext;

    render() {

        // DECISION: las cuentas de pantalla de colas (kiosko y display) se pintan a pantalla
        // completa, sin menú, cabecera ni pie: no hay nada a lo que puedan navegar y la
        // cabecera pide datos que el backend les deniega.
        // flow-root evita que el margin-top de la primera tarjeta colapse fuera del
        // contenedor y deje una franja del fondo blanco del body por encima
        if (esCuentaPantalla(AuthService.getCurrentUser())) {
            return (
                <div className="min-vh-100 bg-light" style={{ display: 'flow-root' }}>
                    <AppContent />
                </div>
            );
        }

        return (
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                <AppSidebar />
                <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                    <ToggleHeaderButton />
                    {/* El Header gestiona internamente su modo compacto cuando headerVisible es false */}
                    <Header />
                    <div className="body flex-grow-1 px-3  mt-4">
                        <AppContent />
                    </div>
                    <AppFooter />
                </div>
            </div>
        )
    }
}
